import { render } from "./excelLikeFileConfig.vue?vue&type=template&id=7b1cbceb&ts=true"
import script from "./excelLikeFileConfig.vue?vue&type=script&lang=ts"
export * from "./excelLikeFileConfig.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__